import { Button, ButtonProps } from '@servicetitan/anvil2';
import { WorkflowStore } from '@servicetitan/financing-workflow-shared';
import { CloseConfirmDialog } from '@servicetitan/financing-application-workflow-shared';
import { PropsWithChildren, useState } from 'react';

export const CancelApplicationButton = ({
    appearance,
    children,
    style,
}: PropsWithChildren<ButtonProps>) => {
    const { setWorkflowStage } = WorkflowStore.useStore();
    const [isDialogOpen, setIsDialogOpen] = useState(false);

    const handleConfirm = () => {
        setIsDialogOpen(false);
        setWorkflowStage('reset');
    };

    const handleCancel = () => {
        setIsDialogOpen(false);
    };

    return (
        <>
            <Button
                appearance={appearance ?? 'secondary'}
                style={style}
                onClick={() => setIsDialogOpen(true)}
            >
                {children}
            </Button>
            <CloseConfirmDialog
                isOpen={isDialogOpen}
                onConfirm={handleConfirm}
                onCancel={handleCancel}
            />
        </>
    );
};
